import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

const ALLOWED_IMAGE_MIME_PREFIX = 'image/';

/**
 * Trusts a Blob URL only if the response's declared content-type is actually an image —
 * refuses to bypassSecurityTrustUrl on unexpected content (e.g. text/html, image/svg+xml with embedded script).
 */
export function toSafeImageBlobUrl(sanitizer: DomSanitizer, blob: Blob): SafeUrl {
  if (!blob || !blob.type?.startsWith(ALLOWED_IMAGE_MIME_PREFIX)) {
    throw new Error(`Unexpected content-type for legend image: ${blob?.type}`);
  }
  return sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
}
